/* ===============================
   WISHLIST — SINGLE SOURCE (HANDLES)
================================ */

function getWishlist() {
  return JSON.parse(localStorage.getItem('wishlist')) || [];
}

function setWishlist(list) {
  localStorage.setItem('wishlist', JSON.stringify(list));
  document.dispatchEvent(new Event('wishlist:updated'));
}

/* ===============================
   HEADER BADGE
================================ */

function updateWishlistHeader() {
  const count = getWishlist().length;
  const badge = document.querySelector('.wishlist-count-badge');
  const icon = document.querySelector('.wishlist-icon');

  if (!badge || !icon) return;

  if (count > 0) {
    badge.textContent = count;
    badge.classList.remove('hidden');
    icon.classList.add('is-filled');
  } else {
    badge.classList.add('hidden');
    icon.classList.remove('is-filled');
  }
}

/* ===============================
   BUTTON STATES (GLOBAL)
================================ */

function updateWishlistButtons() {
  const wishlist = getWishlist();

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const handle = btn.dataset.handle;
    if (!handle) return;

    const active = wishlist.includes(handle);
    btn.classList.toggle('is-active', active);
    btn.textContent = active
      ? '♥ Added to Wishlist'
      : '♡ Add to Wishlist';
  });
}

/* ===============================
   CLICK HANDLER
================================ */

document.addEventListener('click', e => {
  const btn = e.target.closest('.wishlist-btn');
  if (!btn) return;

  const handle = btn.dataset.handle;
  if (!handle) return;

  const wishlist = getWishlist();
  const wishlistGrid = document.getElementById('wishlist-grid');
  const card = btn.closest('.wishlist-card');
  const isWishlistPage = wishlistGrid && card;

  // Wishlist page → remove only
  if (isWishlistPage) {
    const updated = wishlist.filter(h => h !== handle);
    setWishlist(updated);

    card.classList.add('is-removing');
    setTimeout(() => {
      card.remove();

      const empty = document.getElementById('wishlist-empty');
      if (empty && !wishlistGrid.children.length) {
        empty.classList.remove('hidden');
      }
    }, 350);

    return;
  }

  // Everywhere else → toggle
  const updated = wishlist.includes(handle)
    ? wishlist.filter(h => h !== handle)
    : [...wishlist, handle];

  setWishlist(updated);
});

/* ===============================
   WISHLIST PAGE RENDER
================================ */

async function renderWishlistPage() {
  const grid = document.getElementById('wishlist-grid');
  const empty = document.getElementById('wishlist-empty');
  if (!grid) return;

  const wishlist = getWishlist();

  if (!wishlist.length) {
    empty?.classList.remove('hidden');
    return;
  }

  const formatMoney = c =>
    new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: 'ZAR'
    }).format(c / 100);

  for (const handle of wishlist) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) continue;
      const p = await res.json();

      const card = document.createElement('div');
      card.className = 'wishlist-card';
      card.innerHTML = `
        <a href="${p.url}">
          <img src="${p.images[0]}" alt="${p.title}">
          <h3>${p.title}</h3>
          <p>${formatMoney(p.price)}</p>
        </a>

        <div class="wishlist-actions">
          <button
            class="wishlist-move-to-cart"
            data-variant-id="${p.variants[0].id}"
            data-handle="${handle}">
            Move to Cart
          </button>

          <button
            class="wishlist-btn is-active"
            data-handle="${handle}">
            ♥ Remove
          </button>
        </div>
      `;

      grid.appendChild(card);
    } catch (err) {
      console.warn('Wishlist load failed:', handle);
    }
  }
}

/* ===============================
   MOVE TO CART
================================ */

document.addEventListener('click', async e => {
  const btn = e.target.closest('.wishlist-move-to-cart');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const handle = btn.dataset.handle;
  const card = btn.closest('.wishlist-card');
  if (!variantId || !handle || !card) return;

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    const updated = getWishlist().filter(h => h !== handle);
    setWishlist(updated);

    card.classList.add('is-removing');
    setTimeout(() => card.remove(), 350);

    const drawer = document.querySelector('cart-drawer');
    if (drawer?.open) drawer.open();
  } catch (err) {
    console.error('Move to cart failed', err);
  }
});

/* ===============================
   INIT + SYNC
================================ */

document.addEventListener('DOMContentLoaded', () => {
  updateWishlistHeader();
  updateWishlistButtons();
  renderWishlistPage();
});

document.addEventListener('wishlist:updated', () => {
  updateWishlistHeader();
  updateWishlistButtons();
});
